import React from 'react';
import moment from 'moment';
import AddToCartButton from '../../../Store/AddToCartButton';

class SmallFileBlock extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hovered: false
    };
  }

  mouseOver = () => {
    this.setState({
      hovered: true
    });
  };

  mouseLeave = () => {
    this.setState({
      hovered: false
    });
  };

  render() {
    const customColors = this.props.customColors || {
      author: {},
      title: {},
      date: {},
      background: {},
      backgroundHover: {}
    };
    let file = this.props.file;
    file.helper.on(
      'thumbnailLoaded',
      () => {
        this.forceUpdate();
      },
      this
    );
    let href = '/file/' + file.get('id');
    let target = this.props.openInNewTab ? '_blank' : '_self';
    const showThumbnail =
      this.props.showThumbnail == null ? true : this.props.showThumbnail;
    const featured = file.helper.featuredUrl(800);
    let style = {
      maxWidth: '100%'
    };
    let image = featured ? (
      <img src={featured} alt={file.get('title')} style={style} />
    ) : (
      <span className={'fa fa-' + file.icon} />
    );
    const subtitle = this.props.showPassageAsSubtitle
      ? file.get('reference') || ''
      : file.get('subtitle');
    const fontStyle =
      this.props.options && this.props.options.font
        ? {
            fontFamily: 'inherit'
          }
        : {};
    let userOwned = FW.store.get('user') && FW.store.get('user').get('purchased_files').indexOf(file.get('id')) >= 0;
    return (
      <a
        onMouseOver={this.mouseOver}
        onMouseLeave={this.mouseLeave}
        href={href}
        target={target}
        className="media-file"
        style={
          this.state.hovered
            ? customColors.backgroundHover
            : customColors.background
        }
      >
        <div
          className={'row'}
          style={
            this.props.singleFile
              ? {textAlign: 'center', wordBreak: 'break-word'}
              : {wordBreak: 'break-word'}
          }
        >
          <div className={showThumbnail ? 'col-xs-8' : 'col-xs-12'}>
            <h3 style={Object.assign(customColors.title, fontStyle)}>
              {file.get('title')}
            </h3>
            {this.props.showSubtitle ? (
              <h4
                style={Object.assign(customColors.title, fontStyle)}
                id={'subtitle'}
              >
                {subtitle}
              </h4>
            ) : null}
            <h4 style={Object.assign(customColors.author, fontStyle)}>
              {file.get('author')}{' '}
              <small style={Object.assign(customColors.date, fontStyle)}>
                {this.props.hide_dates ? '' : moment(file.get('display_date')).format('LL')}
              </small>
            </h4>
          </div>
          {showThumbnail ? (
            <div className="col-xs-4" style={{textAlign: 'center'}}>
              {image}
            </div>
          ) : null}
        </div>
        {file.get('visibility') === 'private' ? <AddToCartButton
          title={file.get('title')}
          price={file.get('price')}
          id={file.get('id')}
          type="file"
          image={file.helper.featuredUrl(800)}
          owned={userOwned}
        /> : null}
      </a>
    );
  }
}

export default SmallFileBlock;
